import request from '../utils/request'

import { LIST_REGION, LIST_DEPARTMENTS_REGION, LIST_SPECIALTY_SKILL, LIST_EQUIPMENTS,
    DATA_NEW_LEAD, DATA_NEW_PROVIDER, DATA_NEW_TASK, LIST_DEPARTMENTS} from './DatasConstants'

export function listRegion() {
    return {
        type: LIST_REGION,
        payload: request.get('data/regions/')
    }
}

export function listAllDepartments() {
    return {
        type: LIST_DEPARTMENTS,
        payload: request.get('data/departments/')
    }
}

export function listDepartmentByRegion(id) {
    return {
        type: LIST_DEPARTMENTS_REGION,
        payload: request.get('data/region/'+id+'/departements/')
    }
}

export function listSpecialties() {
    return {
        type: LIST_SPECIALTY_SKILL,
        payload: request.get('data/specialties/')
    }
}

export function listEquipments() {
    return {
        type: LIST_EQUIPMENTS,
        payload: request.get('data/equipments/')
    }
}

export const dataNewLead = (date, region) => {
    return {
        type: DATA_NEW_LEAD,
        payload: request.get('dashboard/?type=is_lead&date='+date+(region ? '&region='+region : '' ))
    }
}

export const dataNewProvider = (date, region) => {
    return {
        type: DATA_NEW_PROVIDER,
        payload: request.get('dashboard/?type=is_provider&date='+date+(region ? '&region='+region : '' ))
    }
}

export const dataNewTask = (date, region) => {
    return {
        type: DATA_NEW_TASK,
        payload: request.get('dashboard/?type=is_task&date='+date+(region ? '&region='+region : '' ))
    }
}



// WEBPACK FOOTER //
// ./src/datas/DatasActions.js